/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const { isElement } = require('lodash');

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Add these two components.
Vue.component('chat-messages', require('./components/ChatMessages.vue').default);
Vue.component('chat-form', require('./components/ChatForm.vue').default);
Vue.component('unread-messages-count', require('./components/UnreadMessageCount').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
} 
const app = new Vue({
    el: '#app',
    data: {
        messages: [],
        activeChannelId: '{{ $channelId }}',
        activeChannelHash: '{{ $channelHash }}',
        isEditing: false,
        messageId: null,
        isReplying: false,
        chatInfoText: null,
        messageContent:'',
        forwardingMessages: []
    },
    created() {
        

    },
    methods: {
        addMessage(message) {
            // this.messages.push(message);
            axios.post('/account/private-chat/messages', message).then(response => {
                // console.log(response.data);
            });
        },
        selectChannel(channelId) {
            this.activeChannelId = channelId;
        },
        setActiveHash(hash) {
            this.activeChannelHash = hash;
        },
        editMessage(messageId,message) {
            this.isEditing = true;
            this.messageId = messageId;
            this.$refs.chatForm.newMessage = message;
        },
        deleteMessage(messageId) {
            //get message element <div class="chat-message chat-message-mine" data-id="200" data-mine="1" data-user="2">
            const messageElement = document.querySelector(`div.chat-message[data-id="${messageId}"]`);
            if (!messageElement) {
                console.error('Message element not found');
                return;
            }
            messageElement.classList.add('bg-danger');

            //sweet alert confirmation
            if (!confirm('Are you sure you want to delete this message?')) {
                messageElement.classList.remove('bg-danger');
                return;
            }

            axios.delete(`/account/private-chat/messages/${messageId}`).then(response => {
                this.messages = this.messages.filter(msg => msg.id !== messageId);
                messageElement.innerHTML = 'This message has been deleted.';
            });
        },
        replyToMessage(messageId) {
            const messageElement = document.querySelector(`div.chat-message[data-id="${messageId}"]`);
            if (!messageElement) {
                console.error('Message element not found');
                return;
            }
            this.isReplying = true;
            this.messageId = messageId;
            this.chatInfoText = messageElement.querySelector('.chat-message-content').innerText;
        },
        showForwardMessageModal(messageIds) {
            // Ensure it's always treated as an array
            if (!Array.isArray(messageIds)) {
                messageIds = [messageIds];
            }

            // Collect and join message contents
            // let combinedContent = '';

            // for (let id of messageIds) {
            //     const messageElement = document.querySelector(`div.chat-message[data-id="${id}"]`);
            //     if (!messageElement) continue;

            //     const contentEl = messageElement.querySelector('.chat-message-content');
            //     if (!contentEl) continue;

            //     const text = contentEl.innerText.trim();
            //     if (text) {
            //         combinedContent += text + "\n\n"; // Optional: separate messages with newlines
            //     }
            // }

            // if (!combinedContent) {
            //     console.error('No valid messages found to forward');
            //     return;
            // }

            // this.messageContent = combinedContent;
            $('#allChatsModal').modal('show');
        },
        forwardToChat(channelHash) {
            this.forwardMultipleMessages(channelHash, this.forwardingMessages);
        },
    //    async forwardMultipleMessages(channelHash, messageIds) {
    //         const forwardingChat = chats.find(chat => chat.hash === channelHash);
    //         if (!forwardingChat) {
    //             console.error("Chat not found");
    //             return;
    //         }

    //         for (let id of messageIds) {console.log(id);
    //             const message = this.messages.find(msg => msg.id == id);
    //             if (!message) continue;

    //             const content = message.message;
    //             const formData = new FormData();
    //             formData.append('message', content);
    //             formData.append('chanel', forwardingChat.id);
    //             formData.append('status', 2);

    //             try {
    //                 const response = await axios.post('/account/private-chat/messages', formData, {
    //                     headers: { 'Content-Type': 'multipart/form-data' }
    //                 });

    //                 if (response.status !== 200) {
    //                     console.error(`Failed to forward message ${id}`);
    //                 }
    //             } catch (e) {
    //                 console.error(`Exception forwarding message ${id}:`, e);
    //             }
    //         }

    //         // Optional: open the chat
    //        // $('.chat-item[data-channel="' + forwardingChat.id + '"]').click();
    //         $('#allChatsModal').modal('hide');
    //     },

        async forwardMultipleMessages(channelHash, messageIds) {
            const forwardingChat = chats.find(chat => chat.hash === channelHash);
            if (!forwardingChat) {
                console.error("Chat not found");
                return;
            }

            const promises = messageIds.map(id => {
                const message = this.messages.find(msg => msg.id == id);
                if (!message) return null;

                const formData = new FormData();
                formData.append('message', message.message);
                formData.append('chanel', forwardingChat.id);
                formData.append('status', 2);

                return axios.post('/account/private-chat/messages', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).catch(e => {
                    console.error(`Error forwarding message ${id}`, e);
                });
            }).filter(p => p !== null);

            await Promise.all(promises); // Wait for all to finish

            $('.chat-item[data-channel="' + forwardingChat.id + '"]').click();
            $('#allChatsModal').modal('hide');
        },
        async replyPrivateToMessage(messageId,userId) {
            const messageElement = document.querySelector(`div.chat-message[data-id="${messageId}"]`);
            if (!messageElement) {
                console.error('Message element not found');
                return;
            }
            this.isReplying = true;
            this.messageId = messageId;
            // let message=window.chatMessages.filter(msg => msg?.id == messageId);
            // const response = await axios.get('/account/private-chat/users/'+userId+'/chats', {
            //     headers: { 'Content-Type': 'multipart/form-data' }
            // }); 
            // let channel=response.data;
            // $('.chat-item[data-channel="'+channel.id+'"]').click();
            
            $('a[href="#tab-privates"]').click();
            startPrivateChat(userId);
           

            



            this.chatInfoText = messageElement.querySelector('.chat-message-content').innerText;
        },
        async pinMessage(messageId){
            const formData = new FormData();
            formData.append('edit', true);
            formData.append('message_id', messageId);
            formData.append('is_pinned', 1);
            const response = await axios.post('/account/private-chat/messages', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.status !== 200) throw new Error("Failed to send message");
            $('.chat-item[data-channel="'+response.data.channel+'"]').click();
        }
    }
});
